export default __webpack_public_path__ + "static/media/desktop_report-ioc.a9041730.png";